import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-benefit-item]')) return;

  benefitItemDatalayer();
}

function benefitItemDatalayer() {
  $$('[data-au-benefit-item-link], [data-au-benefit-item-button]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const isLink = el.hasAttribute('data-au-benefit-item-link');
      const titleText = el.closest('[data-au-benefit-item]').querySelector('[data-au-benefit-item-title]')
        ? `${el.closest('[data-au-benefit-item]').querySelector('[data-au-benefit-item-title]').innerText}_`
        : '';
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: isLink ? 'clickEnlace' : 'clickBoton',
        item_id,
      });
    });
  });
}

export default { init };
